module.exports = __webpack_public_path__ + "static/media/thumbnail_smokey.26782fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coverpageThemeThumbnails/thumbnail_smokey.jpg
// module id = 1329
// module chunks = 17